import { useContext, useEffect, useState } from "react";
import { Button, Card, CardContent, Chip } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import DescriptionIcon from "@mui/icons-material/Description";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import SchoolIcon from "@mui/icons-material/School";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import axios from "axios";
import Loader from "../../../../../../routes/Loader";
import { ContextData } from "../../../../../../context/Context";
import { Getrequest } from "../../../../../../context/AxiosRequest";
import { useNavigate } from "react-router-dom";
import { Hand } from "lucide-react";
import baseUrl from "../../../../../../BaseURL";
import { ro } from "faker/lib/locales";

function MyAppDetails() {
  const [applicationDetails, setApplicationDetails] = useState(null);
  const { UserTokens, accesstoken, Value } = useContext(ContextData);
  const [ChangeLoanForm, setChangeLoanForm] = useState(null);
  const [FinalDisbursementLetter, setFinalDisbursementLetter] = useState(null);
  const Navigate = useNavigate();

  useEffect(() => {
    (async () => {
      const path =
        Value === "loan"
          ? "/auth/get_loan_applied_list_for_my_app/"
          : "/auth/get_cholarship_applied_list_for_my_app/";

      const response = await Getrequest(`${path}${UserTokens}`, accesstoken);
      const loanData = await Getrequest(`/auth/get_loan_data/${UserTokens}`,accesstoken);
      const disbursementResponse = await Getrequest(`/auth/get_disbursement_requests_submit_file/${UserTokens}`);
      
      setApplicationDetails(response);
      if(loanData) setChangeLoanForm(loanData?.loanrequest[0]?.loan_category);
      
      if(disbursementResponse && disbursementResponse.length > 0){
        setFinalDisbursementLetter(disbursementResponse[0]);
      }


    })().catch((error) => {
      console.error("Error fetching application details!", error);
    });  




  }, []);

    

   const HandleNavigate = () => {

     // studentloan

       if(ChangeLoanForm === "thirdparty"){
        
        Navigate("/application/offers/inprinciple_offer_thirt_party")

       } else{
         
         Navigate("/application/offers/inprinciple_offer_student")
       }


    




   }

   const handleDownloadFinalLetter = async () => {

     if(FinalDisbursementLetter && FinalDisbursementLetter.file_name){
       try {
         const downloadUrl = `${baseUrl}/get_doc/${FinalDisbursementLetter.file_name}`;
         const response = await fetch(downloadUrl);
         const blob = await response.blob();
         const url = window.URL.createObjectURL(blob);
         const link = document.createElement('a');
         link.href = url;
         link.download = FinalDisbursementLetter.file_name;
         document.body.appendChild(link);
         link.click();
         document.body.removeChild(link);
         window.URL.revokeObjectURL(url);
       } catch (error) {
         console.error('Error downloading file:', error);
       }
     }

     
   };


  if (!applicationDetails) {
    return (
      <div className="flex h-full w-full justify-center items-center p-10">
        <Loader OpenLoader={true} />
      </div>
    );
  }

  return (
    <div className="min-h-screen w-full flex justify-center bg-gray-100 p-4 sm:p-10">
      <div className="w-full max-w-4xl">
        <h3 className="bg-blue-900 text-white text-center text-2xl sm:text-3xl p-4 rounded-xl shadow-md sticky top-0 z-20">
          <b>Application Details</b>
        </h3>

        {applicationDetails.map((detail, index) => (
          <Card
            key={index}
            className="mt-6 shadow-xl rounded-2xl border border-gray-200 bg-white"
          >
            <CardContent className="p-6 space-y-4">
              <div className="flex items-center gap-3 mb-3">
                {Value === "loan" ? (
                  <MonetizationOnIcon className="text-blue-700" fontSize="large" />
                ) : (
                  <SchoolIcon className="text-blue-700" fontSize="large" />
                )}
                <h2 className="text-xl font-bold text-gray-800">
                  {Value === "loan" ? "Loan Application" : "Scholarship Application"}
                </h2>
              </div>

              <div className="grid sm:grid-cols-2 gap-4 text-gray-700 text-sm sm:text-base">
                {Value === "loan" && (
                  <>
                    <InfoRow label="Loan Applied" value={detail.loan_applied} />
                    <InfoRow label="Loan Type" value={detail.loan_type} />
                  </>
                )}

                {Value === "scholarship" && (
                  <>
                    <InfoRow label="Scholarship Applied" value={detail.scholarship_applied} />
                    <InfoRow label="Scholarship Type" value={detail.scholarship_type} />
                  </>
                )}

                <div className="flex items-center gap-2">
                  <b>Status:</b>
                  {detail.verify_status === "Not Verified" && (
                    <Chip
                      icon={<CheckCircleIcon />}
                      label="Pending Verification"
                      className="!bg-blue-900 font-semibold !text-white"
                    />
                  )}
                  {detail.verify_status === "verified" && (
                    <Chip
                      icon={<CheckCircleIcon />}
                      label="Processing Application"
                      className="!bg-sky-950 font-semibold !text-white"
                    />
                  )}
                  {detail.verify_status === "approved" && (
                    <Chip
                      icon={<CheckCircleIcon />}
                      label="Transferred to Bank"
                      className="!bg-green-700 font-semibold !text-white"
                    />
                  )}
                  {detail.verify_status === "pending" && (
                    <Chip
                      icon={<CheckCircleIcon />}
                      label="Returned by verifier"
                      className="!bg-red-900 font-semibold !text-white"
                    />
                  )}
                  {detail.verify_status === "rejected" && (
                    <Chip
                      icon={<CheckCircleIcon />}
                      label="Returned for Revision by Bank"
                      className="!bg-red-900 font-semibold !text-white"
                    />
                  )}
                  {detail.verify_status === "accepted" && (
                    <Chip
                      icon={<CheckCircleIcon />}
                      label="Accepted by Bank"
                      className="!bg-green-600 font-semibold !text-white"
                    />
                  )}
                </div>
                   
                {detail.verify_status === "accepted" && (
                  <div className="flex items-center gap-2 cursor-pointer">
                    <b>Next Step:</b>
                    <Chip
                      icon={<DescriptionIcon />}
                      label="View Offer Letter"
                      className="!bg-blue-950 !text-white shadow-xl hover:!bg-blue-900"
                      onClick={HandleNavigate}
                    />
                  </div>
                )}

                   {/* to be removed */}
                {/*  <div className="flex items-center gap-2 cursor-pointer">
                    <b>Next Step:</b>
                    <Chip
                      icon={<DescriptionIcon />}
                      label="View Offer Letter"
                      className="!bg-blue-950 !text-white shadow-xl hover:!bg-blue-900"
                      onClick={HandleNavigate}
                    />
                  
                  </div> */}

                <InfoRow label="Application Date" value={detail.createdAtDate} />
                {Value === "loan" && (
                  <InfoRow label="Application Time" value={detail.createdAtTime} />
                )}
              </div>

              {/* Download Final Offer Letter Button */}
              {FinalDisbursementLetter && (
                <div className="mt-6 pt-4 border-t border-gray-200">
                  <Button
                    variant="contained"
                    startIcon={<DownloadIcon />}
                    onClick={() => Navigate("/application/offers/final_offer")}
                    className="!bg-green-600 hover:!bg-green-700 !text-white !font-semibold !shadow-lg"
                    fullWidth
                  >
                    View Final Disbursement Letter
                  </Button>
                </div>
              )}
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}

const InfoRow = ({ label, value }) => (
  <p>
    <b className="text-gray-800">{label}:</b> <span className="font-semibold">{value}</span>
  </p>
);

export default MyAppDetails;